import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

export const withTournamentAdministrator =
  <T,>(Component: FC<T>) =>
  ({ ...props }: T): JSX.Element | null => {
    const isCurrentUserAdmin = useSelector(currentTournamentSelector.isCurrentUserAdmin);

    return isCurrentUserAdmin ? <Component {...props} /> : null;
  };
